module.exports = __webpack_public_path__ + "img/question.e0674a92.svg";